import * as React from 'react';
import { ModalContext } from '../modal-provider/modal-provider-core';
const ModalTrigger = (props) => {
    const { children, onClick } = props;
    const { id = '', triggerRef, open } = React.useContext(ModalContext);
    return (React.createElement(React.Fragment, null, React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) {
            return child;
        }
        return React.cloneElement(child, {
            buttonRef: triggerRef,
            elementRef: triggerRef,
            onClick: (event) => {
                event.preventDefault();
                open();
                if (child.props.onClick) {
                    child.props.onClick(event);
                }
                if (onClick) {
                    onClick(event);
                }
            },
            url: `#${id}`,
            role: 'button',
            onKeyDown: (event) => {
                if (event.key === ' ') {
                    event.preventDefault();
                    open();
                }
            },
        });
    })));
};
export default ModalTrigger;
